import React, { useState, useMemo } from 'react';
import ZoomModal from '../../../DeviationViews/ZoomModal';
import Img, { ImgProps } from './ImageBase';
import DeviationMediaService from '../../../utils/DeviationMediaService';
import cleanLinkSrc from '../../../utils/xss/cleanLinkSrc';

const ImgZoomable: React.FC<ImgProps> = props => {
  const [showFullview, setShowFullview] = useState(false);
  const { file, deviation, imgStyles } = props;

  const fullview = useMemo(() => DeviationMediaService.getLargestFullview(deviation), [deviation]);

  return (
    <>
      <div
        onClick={() => {
          setShowFullview(true);
        }}
        style={{ cursor: 'zoom-in', width: '100%' }}
      >
        <Img file={file} deviation={deviation} imgStyles={imgStyles} />
      </div>
      {showFullview && (
        <ZoomModal
          src={cleanLinkSrc(fullview.src)}
          srcSet={fullview.srcSet}
          width={fullview.width}
          height={fullview.height}
          isPixel={false}
          onClose={() => {
            setShowFullview(false);
          }}
        />
      )}
    </>
  );
};
ImgZoomable.displayName = 'ImgZoomable';

export default ImgZoomable;
